import React from "react";
import { Layout } from '../components'
import DynamicZone from "../helpers/dynamicZone";

const Home = ({ pageContext }) => {

  if (!pageContext || !pageContext.data) {
    console.error("Error: pageContext or pageContext.data is missing");
    return null
  }

  const { 
    data,
    footerData
  } = pageContext
  
  // console.log("PageContext --------------------------------------");
  // console.log(pageContext);
  // console.log("Data --------------------------------------");
  // console.log(data);
  // console.log("Fin --------------------------------------");
 
  const { body, pageMetadata, scripts } = data

  return (
    <Layout 
      screenData={data} 
      isHome={true} 
      scriptSelect={scripts}
      pageMetadata={pageMetadata}
      footerData={footerData}
    >
      <section>
        <DynamicZone components={body} isHome={true}/>
      </section>
    </Layout>
  )
}

export default Home;